import styled from 'styled-components';
import { Color } from '../../../common/view/color/color';
import { CssFuncs } from '../../../foundation/css/css.funcs';
const Container = styled.div.withConfig({
  componentId: 'mobile-app_container',
  displayName: 'MobileApp.Container',
})`
  background: ${Color.black2};

  ${CssFuncs.css.absolute({ xy: '0px' })}
  padding: 20px;
`;

export const MobileAppStyle = {
  Container,
};
